<template>
  <div>
    <!-- 取大險種 -->
    <div class="form-group row">
      <label class="col-2 text-right">取大險種</label>
      <div class="col-10 d-inline-grid">
        <input
          type="text"
          class="form-control form-control-inline show-input w-200"
          :class="{ disabled: true }"
        />
      </div>
    </div>

    <!-- 取大期間 -->
    <div class="form-group row">
      <label class="col-2 text-right">取大期間</label>
      <div class="col-10 d-inline-grid">
        <!-- 取大期間-1 -->
        <div class="radio radio-inline ml-15 mb-15">
          <input
            type="radio"
            id="getMax-1"
            v-model="form.max_period"
            value="1"
          />
          <label class="hide-label" for="getMax-1"></label>
          <span class="lh-40 ml-50">終身</span>
        </div>
        <!-- 取大期間-2 -->
        <div class="radio radio-inline ml-15 mb-15">
          <input
            type="radio"
            id="getMax-2"
            v-model="form.max_period"
            value="2"
          />
          <label class="hide-label" for="getMax-2"></label>
          <span class="lh-40 ml-50">繳費期間</span>
        </div>
        <!-- 取大期間-3 -->
        <div class="radio radio-inline ml-15 mb-15">
          <input
            type="radio"
            id="getMax-3"
            v-model="form.max_period"
            value="5"
          />
          <label class="hide-label" for="getMax-3"></label>
          <span class="lh-40 ml-50">繳費期滿</span>
        </div>
        <!-- 取大期間-4 -->
        <div class="radio radio-inline ml-15 mb-15">
          <input
            type="radio"
            id="getMax-4"
            v-model="form.max_period"
            value="4"
          />
          <label class="hide-label" for="getMax-4"></label>
          <input
            type="number"
            class="form-control form-control-inline show-input w-80 ml-50"
            :class="{ 'is-invalid': validate.isMaxStartErr }"
            :min="0"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            maxlength="3"
            v-model.number="form.max_start"
          />
          <select
            class="form-control form-control-inline form-wide w-100"
            v-model="form.max_start_unit"
          >
            <option
              v-for="item in pageControl.coveragePeriodUnits"
              :key="item.value"
              :value="item.value"
            >
              {{ item.text }}
            </option>
          </select>
          <span class="lh-40">到</span>
          <input
            type="number"
            class="form-control form-control-inline show-input w-80"
            :class="{ 'is-invalid': validate.isMaxEndErr }"
            :min="0"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            maxlength="3"
            v-model.number="form.max_end"
          />
          <select
            class="form-control form-control-inline form-wide w-100"
            v-model="form.max_end_unit"
          >
            <option
              v-for="item in pageControl.coveragePeriodUnits"
              :key="item.value"
              :value="item.value"
            >
              {{ item.text }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <!-- 取大項目 -->
    <div class="form-group row">
      <label class="col-2 text-right">取大項目</label>
      <div class="col-10 d-inline-grid">
        <!-- 取大項目-1 -->
        <div class="checkbox radio-inline ml-15 mb-15">
          <input
            type="checkbox"
            id="form8"
            value="1"
            v-model="form.max_item"
          />
          <label class="hide-label" for="form8"></label>
          <span class="lh-40 ml-50">讀取FORM8的值</span>
          <button
            type="button"
            class="btn btn-default btn-sm"
            :disabled="!form8"
            @click="goMaintainForm8()"
          >
            FORM8維護
          </button>
          <!-- 三取大產生Form903 (尚未實作) 
          <button
            type="button"
            class="btn btn-default btn-sm"
            @click="goCreateForm903()"
          >
            三取大產生Form903
          </button>
          -->
        </div>

        <!-- 取大項目-2 -->
        <div class="checkbox radio-inline ml-15 mb-15">
          <input
            type="checkbox"
            id="yearInsuranceAmount"
            value="2"
            v-model="form.max_item"
          />
          <label class="hide-label" for="yearInsuranceAmount"></label>
          <span class="lh-40 ml-50">當年度保額</span>
        </div>

        <!-- 取大項目-3 -->
        <div class="checkbox radio-inline ml-15 mb-15">
          <input
            type="checkbox"
            id="basicInsuranceAmount"
            value="3"
            v-model="form.max_item"
          />
          <label class="hide-label" for="basicInsuranceAmount"></label>
          <input
            type="number"
            class="form-control form-control-inline show-input w-80 ml-50"
            :class="{ 'is-invalid': validate.isBasic_insurance_multipleErr, disabled: !basicInsuranceAmount }"
            :min="0"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            maxlength="9"
            v-model.number="form.basic_insurance_multiple"
          />
          <span class="lh-40">倍基本保額(醫療險日額)</span>
        </div>

        <!-- 取大項目-4 -->
        <div class="checkbox radio-inline ml-15 mb-15">
          <input
            type="checkbox"
            id="totalPremiumMultiple"
            value="4"
            v-model="form.max_item"
          />
          <label class="hide-label" for="totalPremiumMultiple"></label>
          <input
            type="number"
            class="form-control form-control-inline show-input w-80 ml-50"
            :class="{ 'is-invalid': validate.isMultiple_total_premiumErr, disabled: !totalPremiumMultiple }"
            :min="0"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            maxlength="9"
            v-model.number="form.multiple_total_premium"
          />
          <span class="lh-40">倍年繳化總繳保費</span>
        </div>

        <!-- 取大項目-5 -->
        <div class="checkbox radio-inline ml-15 mb-15">
          <input
            type="checkbox"
            id="surrenderValue"
            value="5"
            v-model="form.max_item"
          />
          <label class="hide-label" for="surrenderValue"></label>
          <span class="lh-40 ml-50">解約金</span>
          <!-- 解約金維護 (已實作) 
          <button
            type="button"
            class="btn btn-default btn-sm"
            :disabled="!surrenderValue"
            @click="goTerminationFeeAndReserveMaintain()"
          >
            解約金維護
          </button>
          -->
        </div>

        <!-- 取大項目-6 -->
        <div class="checkbox radio-inline ml-15 mb-15">
          <input
            type="checkbox"
            id="policyValue"
            value="6"
            v-model="form.max_item"
          />
          <label class="hide-label" for="policyValue"></label>
          <span class="lh-40 ml-50">保單價值準備金</span>
          <!-- 保單價值準備金維護 (已實作) 
          <button
            type="button"
            class="btn btn-default btn-sm"
            :disabled="!policyValue"
            @click="goTerminationFeeAndReserveMaintain()"
          >
            保單價值準備金維護
          </button>
          -->
        </div>

        <!-- 取大項目-7 -->
        <div class="checkbox radio-inline ml-15 mb-15">
          <input
            type="checkbox"
            id="policyAccountValue"
            value="10"
            v-model="form.max_item"
          />
          <label class="hide-label" for="policyAccountValue"></label>
          <span class="lh-40 ml-50">保單帳戶價值</span>
        </div>

        <!-- 取大項目-8 -->
        <div class="checkbox radio-inline ml-15 mb-15">
          <input
            type="checkbox"
            id="totalPremiumMultipleSubtractLifeAnnuity"
            value="7"
            v-model="form.max_item"
          />
          <label class="hide-label" for="totalPremiumMultipleSubtractLifeAnnuity"></label>
          <input
            type="number"
            class="form-control form-control-inline show-input w-80 ml-50"
            :class="{ 'is-invalid': validate.isTotal_premium_subtract_lifeannuityErr, disabled: !totalPremiumMultipleSubtractLifeAnnuity }"
            :min="0"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            maxlength="9"
            v-model.number="form.total_premium_subtract_lifeannuity"
          />
          <span class="lh-40">倍年繳化總繳保費扣已領生存年金</span>
        </div>

        <!-- 取大項目-9 -->
        <div class="checkbox radio-inline ml-15 mb-15">
          <input
            type="checkbox"
            id="insuranceAmountAddTotalPremiumMultiple"
            value="11"
            v-model="form.max_item"
          />
          <label class="hide-label" for="insuranceAmountAddTotalPremiumMultiple"></label>
          <input
            type="number"
            class="form-control form-control-inline show-input w-80 ml-50"
            :class="{ 'is-invalid': validate.isInsurance_amount_timesErr, disabled: !insuranceAmountAddTotalPremiumMultiple }"
            :min="0"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            maxlength="9"
            v-model.number="form.insurance_amount_times"
          />
          <span class="lh-40">基本保額＋</span>
          <input
            type="number"
            class="form-control form-control-inline show-input w-80"
            :class="{ 'is-invalid': validate.isTotal_premium_timesErr, disabled: !insuranceAmountAddTotalPremiumMultiple }"
            :min="0"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            maxlength="9"
            v-model.number="form.total_premium_times"
          />
          <span class="lh-40">倍年繳化總繳保費</span>
        </div>

        <!-- 取大項目-10 -->
        <div class="checkbox radio-inline ml-15 mb-15">
          <input
            type="checkbox"
            id="yearInsuranceAmountAddTotalPremiumMultiple"
            value="9"
            v-model="form.max_item"
          />
          <label class="hide-label" for="yearInsuranceAmountAddTotalPremiumMultiple"></label>
          <span class="lh-40 ml-50">當年度保額＋</span>
          <input
            type="number"
            class="form-control form-control-inline show-input w-80"
            :class="{ 'is-invalid': validate.isAdd_multiple_total_premiumErr, disabled: !yearInsuranceAmountAddTotalPremiumMultiple }"
            :min="0"
            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            maxlength="9"
            v-model.number="form.add_multiple_total_premium"
          />
          <span class="lh-40">倍年繳化總繳保費</span>
        </div>

        <!-- 取大項目-11 -->
        <div class="checkbox radio-inline ml-15 mb-15">
          <input
            type="checkbox"
            id="totalContractPremiumCheckBox"
            value="15"
            v-model="form.max_item"
          />
          <label class="hide-label" for="totalContractPremiumCheckBox"></label>
          <span class="lh-40 ml-50">總繳表定保費</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddGetMaxFormulaComponent2",
  data() {
    return {};
  },
  props: {
    pageControl: {
      type: Object,
      default: () => {
        return {};
      },
    },
    form: {
      type: Object,
      default: () => {
        return {};
      },
    },
    validate: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    form8() {
      return this.form.max_item.includes("1");
    },
    basicInsuranceAmount() {
      return this.form.max_item.includes("3");
    },
    totalPremiumMultiple() {
      return this.form.max_item.includes("4");
    },
    surrenderValue() {
      return this.form.max_item.includes("5");
    },
    policyValue() {
      return this.form.max_item.includes("6");
    },
    totalPremiumMultipleSubtractLifeAnnuity() {
      return this.form.max_item.includes("7");
    },
    insuranceAmountAddTotalPremiumMultiple() {
      return this.form.max_item.includes("11");
    },
    yearInsuranceAmountAddTotalPremiumMultiple() {
      return this.form.max_item.includes("9");
    },
  },
  methods: {
    getMexTempSetting() {
      let recordAry = [];
      let recordDetail = {
        //編輯模式
        isEditMode: this.form.isEditMode,
        //取大設定
        getMaxId: this.form.getMaxId,
        //取大期間
        max_period: this.form.max_period,
        max_start: this.form.max_start,
        max_start_unit: this.form.max_start_unit,
        max_end: this.form.max_end,
        max_end_unit: this.form.max_end_unit,
        //取大項目
        max_item: this.form.max_item,
        basic_insurance_multiple: this.form.basic_insurance_multiple,
        multiple_total_premium: this.form.multiple_total_premium,
        total_premium_subtract_lifeannuity: this.form
          .total_premium_subtract_lifeannuity,
        insurance_amount_times: this.form.insurance_amount_times,
        total_premium_times: this.form.total_premium_times,
        add_multiple_total_premium: this.form.add_multiple_total_premium,
      };
      recordAry.push(recordDetail);
      this.$store.dispatch("setRouterPara", {
        pathName: "filterResult",
        setData: recordAry,
      });
    },
    goMaintainForm8() {
      this.getMexTempSetting();
      this.$router.push({
        name: "MaintainForm8",
        params: { pageName: this.pageControl.pageName },
      });
    },
    goTerminationFeeAndReserveMaintain() {
      this.getMexTempSetting();
      this.$router.push({ name: "TerminationFeeAndReserveMaintain" });
    },
    goCreateForm903() {
      this.getMexTempSetting();
      this.$router.push({ name: 'CreateForm903' });
    },
  },
};
</script>
<style lang="scss" scoped>
.lh-40 {
  line-height: 40px;
}
.w-80 {
  width: 80px !important;
}
.mb-15 {
  margin-bottom: 15px;
}
.ml-50 {
  margin-left: 50px !important;
}
.show-input {
  opacity: unset;
  position: unset;
}
.searchArea {
  border-color: #027a39;
  border-width: 3px;
  background-color: white;
}
.d-inline-grid {
  display: inline-grid;
}
.hide-label {
  height: 0;
}
.disabled {
  pointer-events: none;
  opacity: 0.8;
  cursor: not-allowed;
  border-color: transparent;
  color: #989ca2;
  background: #f5f5f5;
  box-shadow: inset 0 -1px 0 0 #e2e2e2;
}
</style>
